/**
 * useRicarica — F-009.3.
 *
 * Mutation che crea una Stripe Checkout Session e, su successo, reindirizza il
 * browser alla pagina di pagamento ospitata da Stripe (`window.location.href`).
 * Su errore mostra un toast. Il redirect è demandato al chiamante via
 * `onSuccess` opzionale così il componente può testare/override il navigate.
 */
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { RicaricaResponse } from '@app/shared';

import { createRicarica, errorMessageFor } from '../lib/wallet-client';

export interface UseRicaricaOptions {
  /** Override del redirect (default: window.location.href = checkoutUrl). */
  onCheckoutUrl?: (url: string) => void;
}

export function useRicarica(opts: UseRicaricaOptions = {}) {
  return useMutation<RicaricaResponse, unknown, number>({
    mutationFn: (amountCents: number) => createRicarica(amountCents),
    onSuccess: (data) => {
      if (opts.onCheckoutUrl) {
        opts.onCheckoutUrl(data.checkoutUrl);
      } else {
        window.location.href = data.checkoutUrl;
      }
    },
    onError: (err) => {
      toast.error(errorMessageFor(err));
    },
  });
}
